import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M8.42 14.762v.004c0 .643-.265 1.257-.733 1.7l-.293.276a2.49 2.49 0 0 0-.78 1.81v2.546M14.099 12.148v2.808c0 .955-.58 1.817-1.473 2.187l-1.427.592a2.37 2.37 0 0 0-1.472 2.188v1.485"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M4.342 12.742c.724 1.029 1.855 1.747 3.167 1.455 1.83.746 5.458.712 5.525-2.61h4.581c2.136 0 3.453-2.373 1.928-3.593.237-2.17-1.78-3.56-2.924-3.39-.737-1.356-3.45-1.762-4.534-1.118C10.73 2.4 7.407 3.248 6.594 4.909c-1.424.34-3.051 2.17-2.475 3.73"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M12 4v1.372c0 .792.642 1.434 1.434 1.434h1.12M7.51 14.197v-1.613c0-1.075.87-1.946 1.945-1.946h1.037M19.659 7.034l-.475.566c-.504.6-1.274.95-2.09.95h-.469M10.723 8.345h-.625c-.678 0-1.227-.55-1.227-1.227V6.93A2.02 2.02 0 0 0 6.849 4.91h-.255M2.771 18.142a1.371 1.371 0 1 0 0-2.743 1.371 1.371 0 0 0 0 2.743M20.772 4.142a1.371 1.371 0 1 0-.001-2.743 1.371 1.371 0 0 0 0 2.743"
    />
  </svg>
);
export const NeuralIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
